import React from 'react'

export const CarpoolManagementIcon: React.FC<{ color?: string; size?: number }> = ({
  color = '#333333',
  size = 24,
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    stroke={color}
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <title>Manage Carpool Schedule</title>
    {/* The calendar shape (unchanged) */}
    <rect x='3' y='4' width='18' height='18' rx='2' ry='2'></rect>
    <line x1='16' y1='2' x2='16' y2='6'></line>
    <line x1='8' y1='2' x2='8' y2='6'></line>
    <line x1='3' y1='10' x2='21' y2='10'></line>

    {/* NEW, more recognizable steering wheel */}
    <circle cx='12' cy='16' r='3'></circle>
    <circle cx='12' cy='16' r='1'></circle>
    <line x1='12' y1='13' x2='12' y2='16'></line>
    <line x1='14.12' y1='17.5' x2='12' y2='16'></line>
    <line x1='9.88' y1='17.5' x2='12' y2='16'></line>
  </svg>
)
